var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.props.row.badgelist),function(badge,badgeKey){return _c('div',{key:badgeKey,staticClass:"d-inline"},[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(badge.tooltip),expression:"badge.tooltip"}],class:'badge ' + badge.styling},[_vm._v(_vm._s(badge.text))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }